// extracted by mini-css-extract-plugin
module.exports = {"tooltipLoadingState":"style_tooltipLoadingState__3Cwy3","tooltipErrorState":"style_tooltipErrorState__1-EwB"};